import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=010e244e&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e244e",
  null
  
)

export default component.exports